export default __webpack_public_path__ + "static/media/chime7.92585bd4.mp3";